<template>
  <div class="start">
    <Header />
    <Hero step="edit" />
    <FahrtAuswahlEdit />
    <BergfahrtUhrzeit />
    <TalfahrtUhrzeit />
    <SubsetUhrzeit />
    <Bearbeitung_Fail />
    <SlideNavigation
      prev-route="/"
      next-route="/"
    />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import FahrtAuswahlEdit from '@/components/FahrtAuswahlEdit.vue'
import BergfahrtUhrzeit from '@/components/BergfahrtUhrzeit.vue'
import TalfahrtUhrzeit from '@/components/TalfahrtUhrzeit.vue'
import Bearbeitung_Fail from '@/components/Bearbeitung_Fail.vue'
import SlideNavigation from '@/components/SlideNavigation.vue'

import Footer from '@/components/Footer.vue'
import SubsetUhrzeit from "../components/SubsetUhrzeit.vue";

export default {
  name: 'EditView',
  components: {
    SubsetUhrzeit,
    Header,
    Hero,
    FahrtAuswahlEdit,
    BergfahrtUhrzeit,
    TalfahrtUhrzeit,
    Bearbeitung_Fail,
    SlideNavigation,
    Footer
  },
  data() {
    return {}
  },
  mounted() {
    this.$store.state.isLoading = false

    window.scrollTo(0, 0);
  }
}
</script>
